/**
 * @file 品牌升级页
 * @author WangZhuang
 */

import React, {Component} from 'react';

import {Carousel, WingBlank} from 'antd-mobile';
import './index.less';

export default class Brand extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/pages/brand.html';
        }

    }

    componentDidMount() {
        // 解决工具栏底部遮挡问题
        document.documentElement.style.height = window.innerHeight + 'px';

        if (this.isIos()) {
            document.body.addEventListener('touchmove', this.preventDefault, {passive: false});
        }
    }

    componentWillUnmount() {
        if (this.isIos()) {
            document.removeEventListener('touchmove', this.preventDefault, {passive: false});
        }
    }

    preventDefault(e) {
        e.preventDefault();
    }

    render() {
        const style = this.isSafari() && this.isIos() ? {height: '90vh'} : null;
        return (
            <div className={'brand'} style={style}>
                <WingBlank>
                    <Carousel
                        className="my-carousel"
                        vertical
                        dots={false}
                        selectedIndex={this.state.selectedIndex}
                        afterChange={index => {
                            this.setState({
                                selectedIndex: index
                            });
                        }}
                    >
                        <div style={style} className="v-item carousel1">
                            <a href={'/m/'} className={'brand-logo'}>
                                <img src={require('../../asset/image/brand/logo.svg')} width={'100%'} alt={'logo'} />
                            </a>
                            <div className={'car1-text'}>
                                有 A I， 更 安 全
                            </div>
                        </div>
                        <div style={style} className="v-item carousel2 align-center">
                            <div>
                                <div className={'car-title'}>
                                    品牌升级
                                </div>
                                <div className={'car-text'}>
                                    重新定义AI时代的安全。AI的安全，安全的AI，新时代的
                                    安全生态系统面临全新的机遇与挑战。基于在安全领域
                                    20年安全实践的总结与提炼，百度安全以AI为核心，以大
                                    数据为基础，为生态合作伙伴提供技术支点及完善的产品
                                    解决方案，促进AI时代的产业共赢。
                                </div>
                                <div className={'car2-img'}>
                                    <div className={'img1'}>
                                        <img src={require('../../asset/image/brand/car2-logo1.png')} alt="百度安全" />
                                        <div className={'img-hint'}>
                                            <div>
                                                Before
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'img2'}>
                                        <img src={require('../../asset/image/brand/car2-logo2.png')} alt="百度安全" />
                                        <div className={'img-hint'}>
                                            <div>
                                                After
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={style} className="v-item carousel3 align-center">
                            <div>
                                <div className={'car-title'}>
                                    百度安全 品牌使命
                                </div>
                                <div className={'car-text'}>
                                    百度安全旨在以AI为核心构建安全生态系统，对内为百度
                                    公司各个业务保驾护航，对外向全行业输出能力与解决方
                                    案，让全行业享受更安全的AI所来带来的变革。
                                </div>
                                <div className={'car3-img'}>
                                    <div>
                                    </div>
                                    <div>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={style} className="v-item carousel4">
                            <div className={'car4-con align-center'}>
                                <div>
                                    <div className={'car-title'}>
                                        开放 • 安全
                                    </div>
                                    <div className={'car-text'}>
                                        <div style={{fontSize: '.4rem'}}>百度安全服务平台</div>
                                        在提供标准化安全产品及服务基础上，为合作伙伴提供定制化企业级安全解决方案<br />
                                        <div style={{fontSize: '.4rem', marginTop: '.3rem'}}>全网安全大数据仓库</div>
                                        基于海量威胁情报，提供大数据分析和安全情报共享服务<br />
                                        <div style={{fontSize: '.4rem', marginTop: '.3rem'}}>安全生态系统</div>
                                        以技术开源、专利共享、标准驱动为理念，联合互联网公
                                        司、安全厂商、终端制造商、高校及科研机构，共建安全
                                        的AI时代<br />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={style} className="v-item carousel5">
                            <div className={'car5-con align-center'}>
                                <div>
                                    <div className={'car-title'}>
                                        智能 • 安全
                                    </div>
                                    <div className={'car-text'}>
                                        以AI为核心，打造基于大数据和机器学习的纵深防御，显
                                        著提高安全在数据层、感知层和执行层的效率。有AI，更
                                        安全。从海量威胁情报，到黑色产业链追踪，助力智慧公
                                        安新业态
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={style} className="v-item carousel6">
                            <div className={'car6-con align-center'}>
                                <div>
                                    <div className={'car-title'}>
                                        可靠 • 安全
                                    </div>
                                    <div className={'car-text'}>
                                        AI安全、云安全、移动安全、数据安全、DuEdge安全、
                                        IoT安全，业务安全，七大安全解决方案矩阵，基于百度
                                        在安全领域20年安全实践的总结与提炼，向全行业进行
                                        输出能力与解决方案
                                    </div>
                                    <div className={'car6-img just-center'}>
                                        <img src={require('../../asset/image/brand/6-icon.svg')} alt="安全" />
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div style={style} className="v-item carousel7 align-center">
                            <div>
                                <div className={'car-title'}>
                                    结构之思
                                </div>
                                <div className={'car-text'}>
                                    百度安全全新LOGO结构为中间镂空的“百”字建筑体，打
                                    造开阔、宏伟、威严之感，外形轮廓为硬朗的盾牌，传递
                                    以AI为核心百度安全开放、智能、可靠的品牌形象。
                                </div>
                                <div className={'car7-img'}>
                                    <img src={require('../../asset/image/brand/p7.svg')} alt="百度" width={'100%'} />
                                </div>
                            </div>
                        </div>
                        <div style={style} className="v-item carousel8">
                            <div className={'car8-con align-center'}>
                                <div>
                                    <div className={'car-title'}>
                                        VI 规范
                                    </div>
                                    <div className={'car-text'}>
                                        百度安全品牌升级，logo的造型为中间镂空的“百”字形成的建筑体，给人开阔视野和宏伟可靠的视觉感受。
                                        通过严格标准的语言和系统化视觉符号，将新形象理念宗旨，行为和功能传给社会公众，起到强化品牌形象的作用。
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={style} className="v-item carousel9">
                        </div>
                        <div style={style} className="v-item carousel10">
                            <div className={'car10-con align-center'}>
                                <div style={{width: '100%'}}>
                                    <div className={'car10-title'}>更多业务详情请访问 百度安全</div>
                                    <div className={'just-center'}>
                                        <div className={'car10-link'}>anquan.baidu.com</div>
                                        <a href={'https://anquan.baidu.com/'} className={'car10-click'}>点击进入</a>
                                    </div>
                                </div>
                            </div>
                            <div className={'back-top'} onClick={() => {
                                this.setState({
                                    selectedIndex: 0
                                });
                            }}>
                            </div>
                        </div>
                    </Carousel>
                </WingBlank>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/brand/index.js